import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="grid min-h-screen place-items-center bg-canvas p-8 text-center">
          <div>
            <h1 className="font-display text-2xl font-bold text-slate-900">Something went wrong</h1>
            <p className="mt-2 text-sm text-slate-500">
              Refresh the page — if it keeps happening, email agency@smartmarketer.com.
            </p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
